import React, {Component} from 'react';
import styles from "../utilita/ReportStatistici.module.css";
import Table from "../../components/table/Table";
import Utils from '../../utils/Utils';
import {withTranslation} from "react-i18next";
import SegnalazioniServices from "../../services/SegnalazioniServices";
import toasterConfig from "../../config/toasterConfig";
import Spinner from "../../components/spinner/Spinner";
import ToasterSingleton from "../../singleton/ToasterSingleton";
import Icon from "../../components/icon/Icon";
import SessioneUtente from "../../sessionManager/SessioneUtente";
import Ruoli from "../../utils/Ruoli.json";
import TooltipIcon from "../../components/tooltip/Tooltip";
import $ from "jquery";


class ExportSegnalazioni extends Component {

    state = {
        rowsTable: [],
        cols: [
            {key: "timestampRichiesta", name: "Data Richiesta", sortDirection: "none"},
            {key: "tipoData", name: "Tipo data"},
            {key: "dataDa", name: "Data da", sortDirection: "none"},
            {key: "dataA", name: "Data a", sortDirection: "none"},
            {key: "malattie", name: "Malattie", sortDirection: "none"},
            {
                key: "scarica",
                name: "Download",
                id: "it-download"
            },
            {
                key: "elimina",
                name: "Elimina richiesta",
                id: "it-delete"
            },

        ],
        totalElements: 0,
        page: 0,
        totalPages: 0,
        size: 10,
        loading: false,
        filtri: {},
        malattie: JSON.parse(sessionStorage.getItem("malattieExport")),
        malattiePerCodice: JSON.parse(sessionStorage.getItem("malattiePerCodice")),
        sendRequest: false,
        ruoloUtente: SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp.descrizione || SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Sisp_HIV.descrizione ? SessioneUtente.getInstance().ulss : SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione ? SessioneUtente.getInstance().ruoliUtente : null

    }
    rows =
        {
            tipoData: {
                id1: "dataButton1",
                id2: "dataButton2",
                name: "tipoData",
                text1: "Data inizio sintomi",
                text2: "Data di segnalazione",
                field1: "dataButton1",
                field2: "dataButton2"
            },
            data: {
                id: "dataDa",
                id1: "dataA",
                radioNav: "si",
                text: "Data di inizio sintomi",
                text1: "Data di segnalazione",
                field: "dataDa",
                fieldRadio: "dataA",
                placeholder: "Data da",
                placeholder1: "Data a"
            },
            malattia: {
                id: "malattia",
                text: "malattia",
                field: "malattia",
                suggestions: this.state.malattie,
                keyField: "codice",
                descriptionField: "codDesc",
                suggestionField: "descrizione",
            },
        }

    constructor(props) {
        super(props);

        this.setStateGenerico = this.setStateGenerico.bind(this)
        this.renderTable = this.renderTable.bind(this);
        this.aggiungiToaster = this.aggiungiToaster.bind(this)
        this.changePageTable = this.changePageTable.bind(this);
        this.changePageTable = this.changePageTable.bind(this);
        this.createJsonExport = this.createJsonExport.bind(this)
        this.getTabella = this.getTabella.bind(this);
        this.mapDatiPerTabella = this.mapDatiPerTabella.bind(this);
        this.onClickButtonsTabella = this.onClickButtonsTabella.bind(this)
        this.hideTooltip=this.hideTooltip.bind(this);
        this.showTooltip=this.showTooltip.bind(this);

    }

    setStateGenerico(object) {
        this.setState(object)
    }

    componentDidMount() {

        ToasterSingleton.instance().sottoscrizione(this)
        let pagination = {
            paginazione: true,
            ruolo: this.state.ruoloUtente
        }
        this.getTabella(pagination);
        let object = {
            stato: this.state.filtri,
            setStatePadre: this.setStateGenerico,
            rows: this.rows,
            applicaFiltri: () => {
                this.sendRequest()
            }
        }
        this.props.creaFiltri({filtri: object})
    }

    getTabella(pagination) {
        SegnalazioniServices.getTabellaExport(pagination)
            .then((data) => {

                let rows = this.mapDatiPerTabella(data.data.content)
                this.setState({
                    rowsTable: rows, totalElements: data.data.totalElements,
                    totalPages: data.data.totalPages, page: pagination.page,
                    loading: false
                });
            })
            .catch(() => {
                console.log("[Error] GetExportSegnalazioni in errore ");
                this.setState({loading: false})
            })
    }
    showTooltip(id){$('#tooltipExport'+id).css('opacity', '1');}
    hideTooltip(id){$('#tooltipExport'+id).css('opacity', '0');}

    mapDatiPerTabella(rows) {
        rows.forEach(object => {
            const tipo = object.tipoData === "dataInizioSintomi" ? "Data inizio sintomi" : "Data di segnalazione";
            let newMalattie = "";
            if (object.idFile) {
                object.scarica = <span onClick={() => this.onClickButtonsTabella(object.idRichiesta, true)}><Icon
                    style={{fill: "#1b7ea9", cursor: "pointer"}} id={"it-download"} classes={"icon-sm"}></Icon></span>
            }else if(!object.idFile && object.stato==="fallito"){
                object.scarica = <><Icon onMouseOver={()=>this.showTooltip(object.idRichiesta)} onMouseOut={()=>this.hideTooltip(object.idRichiesta)}
                    style={{fill: "#1b7ea9"}} id={"it-warning-circle"} classes={"icon-sm"}></Icon>
                <TooltipIcon width={"auto"} id={"tooltipExport"+object.idRichiesta} text={["Nessuna segnalazione nel periodo selezionato"]}></TooltipIcon></>
            }else if(!object.idFile && object.stato==="errore"){
                object.scarica = <><Icon onMouseOver={()=>this.showTooltip(object.idRichiesta)} onMouseOut={()=>this.hideTooltip(object.idRichiesta)}
                                         style={{fill: "#1b7ea9"}} id={"it-close-circle"} classes={"icon-sm"}></Icon>
                    <TooltipIcon width={"auto"} id={"tooltipExport"+object.idRichiesta} text={"Errore: "+object.tipoErrore}></TooltipIcon></>
            }else {
                object.elimina = <span onClick={() => this.onClickButtonsTabella(object.idRichiesta, false)}><Icon
                    style={{fill: "red", cursor: "pointer"}} id={"it-delete"} classes={"icon-sm"}></Icon></span>
            }
            for (const mal of object.malattie) {
                newMalattie += this.state.malattiePerCodice[mal].descrizione + " | ";
            }
            object.malattie = newMalattie.substring(0, newMalattie.length - 2);
            object.tipoData = tipo;
            object.timestampRichiesta = Utils.transformTimeStampForFrontend(object.timestampRichiesta);
            object.dataDa = Utils.transformTimeStampForFrontend(object.dataDa);
            object.dataA = Utils.transformTimeStampForFrontend(object.dataA);
        });
        return rows
    }

    createJsonExport() {
        let dataDa = Utils.transformDateForBackend(this.state.filtri.dataDa);
        let dataA = Utils.transformDateForBackend(this.state.filtri.dataA);
        let ObjectForBackEnd = {}
        ObjectForBackEnd["malattie"] = this.state.filtri.malattia
        ObjectForBackEnd["tipoData"] = this.state.filtri.tipoData ? "dataInizioSintomi" : "dataSegnalazione";
        ObjectForBackEnd["dataDa"] = dataDa
        ObjectForBackEnd["dataA"] = dataA
        ObjectForBackEnd["ruolo"] = this.state.ruoloUtente

        return Utils.removeEmptyValueFromObject(ObjectForBackEnd)
    }

    sendRequest() {
        if (this.state.filtri.tipoData === "") {
            return this.aggiungiToaster("Selezionare il tipo di data per il periodo di riferimento")
        }
        if (!this.state.filtri.dataDa) {
            return this.aggiungiToaster("Campo \"Data Da\" mancante")
        }
        if (!this.state.filtri.dataA) {
            return this.aggiungiToaster("Campo \"Data A\" mancante")
        }
        if (Utils.checkDateIntervalMinore(this.state.filtri.dataA, this.state.filtri.dataDa)) {
            return this.aggiungiToaster("Il campo \"Data Da\" deve essere minore del campo \"Data A\"")
        }
        if (this.state.filtri.malattia.length < 1) {
            return this.aggiungiToaster("Selezionare almeno una malattia")
        }
        if (this.state.filtri.malattia.length > 5) {
            return this.aggiungiToaster("Non è possibile selezionare più di 5 malattie")
        }
        this.setState({loading: true})
        let pagination = {
            paginazione: true,
            size: this.state.size,
            page: 0,
            ruolo: this.state.ruoloUtente
        }
        let jsonReport = this.createJsonExport();
        SegnalazioniServices.richiestaExportSegnalazioni(jsonReport).then(() => {
            console.log("Export richiesto correttamente");
            this.getTabella(pagination);
        }).catch(() => {
            console.log("[Error] PostExportSegnalazioni errore ");
            this.setState({loading: false})
        });
    }

    changePageTable(sort, direction, page, size) {
        this.setState({loading: true})
        let params = {
            page: page,
            size: size,
            paginazione: true,
            ruolo: this.state.ruoloUtente
        }
        if (sort) {
            params.sort = sort
        }
        if (direction) {
            params.order = direction
        }
        this.getTabella(params);
    }

    aggiungiToaster(text) {

        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now()
        })
    }

    onClickButtonsTabella(idRichiesta, download) {
        this.setState({loading: true})
        if (download) {
            SegnalazioniServices.getFileExportSegnalazioni(idRichiesta).then((res) => {
                if (res.status === 200) {
                    Utils.downloadReport(res.data.file.data, res.data.nome, "csv")
                }
                this.setState({loading: false})
            }).catch(() => {
                this.setState({loading: false})
                return this.aggiungiToaster("Errore download FileExport");
            });
        } else {
            SegnalazioniServices.deleteRichiestaExportSegnalazioni(idRichiesta).then((res) => {
                let pagination = {
                    paginazione: true,
                    ruolo: this.state.ruoloUtente
                }
                this.getTabella(pagination);
                this.setState({loading: false})
            }).catch(() => {
                this.setState({loading: false})
                return this.aggiungiToaster("Errore eliminazione richiesta");
            });
        }
    }


    renderTable(cols, rows) {
        return (
            <Table
                id={"exportSegnalazioniTable"}
                cols={cols}
                rows={rows}
                empty={rows && rows.length === 0}
                onSelectCheckbox={this.selectRow}
                emptyMsg={"Non sono presenti richieste."}
                lengthEditable={true}
                bigTable={true}
                homePage={true}
                reportStatistici={true}
                totalElements={this.state.totalElements}
                totalPages={this.state.totalPages}
                page={this.state.page}
                changePage={this.changePageTable}
                changePagination={this.changePageTable}
            />
        );
    }

    render() {
        return (
            <div>
                {ToasterSingleton.instance().renderToaster()}
                <div>
                    <div style={{paddingTop: "2rem"}}>
                        <div className="container mt-3">
                            <div className={styles.contenitoreTabella} style={{marginTop: "2px"}}>
                                {this.renderTable(this.state.cols, this.state.rowsTable)}
                            </div>
                        </div>
                    </div>
                    {this.state.loading ?
                        <div>
                            <Spinner/>
                        </div> : <div/>}
                </div>
            </div>
        );
    }
}

export default withTranslation('common')(ExportSegnalazioni)
